import { usePageTitle } from '../../../hooks/usePageTitle';
import { formatCMSContent } from '../../../utils/templater';

const PAGE_NAME = 'pageName';

export const useMetaTagsFormat = () => {
  const title = usePageTitle();

  return (string) => {
    const options = {
      [PAGE_NAME]: title,
    };

    return string ? formatCMSContent(string, options) : '';
  };
};
